// @ts-strict-ignore
import React, { useMemo } from 'react'
import { View } from 'react-native'

import styled from 'styled-components/native'

import Typography from 'APP/Converse/Typography'

import TimeslotButton from './timeslotButton'
import { AvailabilitySlot } from '@dialogue/timekeeper'

interface Props {
  title: string
  appointments: readonly Readonly<AvailabilitySlot>[]
  selectedAppointment?: AvailabilitySlot | null
  onSelect: (appointment: AvailabilitySlot) => void
}

const Header = styled.View`
  padding-bottom: 12px;
  align-content: center;
`
const SectionContainer = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 5%; // percentage so 3 buttons always fit a row
`

export const TimeslotSection: React.FC<Props> = ({
  title,
  appointments,
  selectedAppointment,
  onSelect,
  ...rest
}) => {
  const buttons = useMemo(
    () =>
      appointments.map((appointment, index) => {
        return (
          <TimeslotButton
            key={appointment.start_at}
            onSelect={onSelect}
            appointment={appointment}
            selected={appointment?.start_at === selectedAppointment?.start_at}
            testID={`TIMESLOT_BUTTON_${index}`}
          />
        )
      }),
    [appointments, selectedAppointment, onSelect]
  )

  return (
    <View {...rest}>
      <Header>
        <Typography variant="bodyNormalBold" align="center">
          {title}
        </Typography>
      </Header>
      <SectionContainer>{buttons}</SectionContainer>
    </View>
  )
}

export default TimeslotSection
